"use client";

import { useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

const BusTabsNav = ({ currentTab }) => {
  const navigate = useNavigate();

  const handleTabChange = (value) => {
    if (value === "tracking") {
      navigate("/dashboard/live-tracking");
      return;
    }
    localStorage.setItem("busActiveTab", value);
    navigate("/dashboard/bus-routes");
  };

  return (
    <Tabs value={currentTab} onValueChange={handleTabChange} className="w-full">
      <TabsList className="mb-6 grid grid-cols-5 md:grid-cols-5 gap-2 bg-white p-1 border rounded-lg">
        <TabsTrigger value="tracking" className="rounded-md data-[state=active]:bg-[#0263cc] data-[state=active]:text-white">
          Live Tracking
        </TabsTrigger>
        <TabsTrigger value="vehicles" className="rounded-md data-[state=active]:bg-[#0263cc] data-[state=active]:text-white">
          Vehicle Management
        </TabsTrigger>
        <TabsTrigger value="students" className="rounded-md data-[state=active]:bg-[#0263cc] data-[state=active]:text-white">
          Student Mapping
        </TabsTrigger>
        <TabsTrigger value="drivers" className="rounded-md data-[state=active]:bg-[#0263cc] data-[state=active]:text-white">
          Drivers
        </TabsTrigger>
        <TabsTrigger value="fuel" className="rounded-md data-[state=active]:bg-[#0263cc] data-[state=active]:text-white">
          Fuel Management
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default BusTabsNav;
